/* global EpgEnabled, ProfileEnabled */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Waypoint } from 'react-waypoint';
import _ from 'lodash';
import ReactTimeout from 'react-timeout';
import classNames from 'classnames';
import BreadcrumbsComponent, { breadcrumbsWatchParser } from 'components/Breadcrumbs';
import Loader from 'components/Loader';
import { WATCH_RELATED_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import Carousel from 'components/Carousel';
import MobileWebRoadblock from 'componentsV2/MobileWebRoadblock';
import { deactivateWindowPreroll, getOptimizelyWatchClipsLayout } from 'helpers/OptimizelyHelper';
import {
  getPreviousPathname,
  helperGetHomeUrl,
  helperGetLiveUrl,
  helperGetUpsellUrl,
  redirectToExternalUrl,
} from 'helpers/RouteHelper';
import {
  clearVideo as clearGlobalVideo,
  setDisableRender as setGlobalVideoDisabled,
  clearLiveRestart as clearGlobalLiveRestart,
  setScreenInControlOfState as setGlobalPlayerScreenInControlOfState,
  setVideoPanel as setGlobalVideoPanel,
  handleVodSectionClicked,
} from 'components/VideoPlayerGlobal/Actions';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import { PAGE_WATCH } from 'helpers/PageHelper';
import { renderGrid } from 'helpers/GridHelper';
import Schema from 'componentsV2/Schema';
import { SCHEMA_TYPES } from 'componentsV2/Schema/SchemaHelper';
import {
  clipsVideoProcessor,
  seriesVideoProcessor,
  watchListPlaylistVideoProcessor,
  watchListVideoProcessor,
  watchPlaylistVideoProcessor,
  watchVideoProcessor,
} from 'helpers/VideoProcessorHelper';
import {
  getErrorComponent,
  isClip,
  isEpisode,
  isMovie,
  isNationEntitled,
  isNationLicensed,
  isStaticRender,
} from 'helpers/ContentHelper';
import {
  isMobileBreakpoint,
  isTabletBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
} from 'helpers/BreakpointHelper';
import {
  checkRecommendationIdOnClick,
  Events,
  getSegmentModelMetadata,
  handleAnalytics,
  handleTealiumButtonAction,
  PageNames,
  SegmentActionLocations,
  setOptimizelyCollectionViewedEvent,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { brandOverrideMetaTags, setHelmetTags } from 'helpers/HelmetHelper';
import { getPlaylistVariantActive } from 'helpers/AmplitudeHelper';
import { fetchSeries, clearSeriesDetail } from 'screens/ContentDetail/ContentDetailActions';
import CarouselTheme from 'screens/ContentDetail/styles/SeriesDetailsCarousel.css';
import CarouselTileTheme from 'screens/ContentDetail/styles/SeriesDetailsCarouselTile.css';
import breadcrumbsTheme from 'screens/Watch/styles/Breadcrumbs.css';
import FloatingStartFreeTrial from 'components/FloatingStartFreeTrial';
import { mobileWebRoadblockEnabled } from 'helpers/ConfigHelper';
import { setUserBookmarks } from '../Collection/Actions';
import tileGridTheme from './styles/WatchTileGrid.css';
import tileStyle from './styles/WatchTile.module.scss';
import Style from './Watch.module.scss';
import { fetchWatch, fetchWatchPanels, clearWatch, fetchMovieDetail } from './WatchActions';
import { getSectionTitleData, PANEL_TYPE_VIDEOS, RESTART_TYPE_LIVE } from './WatchHelpers';

import {
  makeSelectAppRecommendationIdData,
  makeSelectGlobalUpNextHeadline,
  makeSelectGlobalUpNextVideo,
  makeSelectGlobalVideoPanelVideo,
  makeSelectGlobalVideoRestartVideo,
  makeSelectGlobalVideoVideo,
} from './selectors';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    canHideControls: true,
    carouselLimit: 3,
    defaultHideAltHeader: false,
    gridMovieToggleLimit: 8,
    gridPrimaryToggleLimit: 4,
    gridToggleLimit: 4,
    gridUpNextToggleLimit: 15,
    playerMetadataOverlay: true,
    renderInfoInDetail: false,
    renderList: false,
    roundArrows: true,
    showCarouselArrows: true,
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    subtitleLines: 2,
    suppressNetworkIcon: false,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_WEB]: {
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    canHideControls: true,
    carouselLimit: 3,
    defaultHideAltHeader: false,
    gridMovieToggleLimit: 8,
    gridPrimaryToggleLimit: 4,
    gridToggleLimit: 4,
    gridUpNextToggleLimit: 12,
    playerMetadataOverlay: true,
    renderInfoInDetail: false,
    renderList: false,
    roundArrows: true,
    showCarouselArrows: true,
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    subtitleLines: 2,
    suppressNetworkIcon: false,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_TABLET]: {
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    canHideControls: false,
    carouselLimit: 3,
    defaultHideAltHeader: true,
    gridMovieToggleLimit: 3,
    gridPrimaryToggleLimit: 6,
    gridToggleLimit: 3,
    overrideShowNetworkBug: true,
    playerMetadataOverlay: false,
    renderInfoInDetail: true,
    renderList: true,
    roundArrows: true,
    showCarouselArrows: true,
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    subtitleLines: 2,
    suppressNetworkIcon: false,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    canHideControls: false,
    carouselLimit: 3,
    defaultHideAltHeader: true,
    gridMovieToggleLimit: 3,
    gridPrimaryToggleLimit: 6,
    gridToggleLimit: 3,
    overrideShowNetworkBug: true,
    playerMetadataOverlay: false,
    renderInfoInDetail: true,
    renderList: true,
    roundArrows: true,
    showCarouselArrows: true,
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    subtitleLines: 2,
    suppressNetworkIcon: false,
    useScrollableDiv: false,
  },
};

class Watch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playlist: null,
      initialFreemiumVisibility: false,
      upNextPanel: null,
      primaryPanels: null,
    };
    this.state.upNextPanel = this.renderUpNextPanelVideos();
    this.ignoreUnmountReferrerAnalytics = false;
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.panelRenderPosition = 0;
  }

  componentDidMount() {
    const {
      setGlobalPlayerScreenInControlOfState,
      setGlobalVideoDisabled,
      profileBookmarks,
      setUserBookmarks,
      setWatchPage,
    } = this.props;
    window.scrollTo(0, 0);
    if (setWatchPage) setWatchPage(true);
    const source = PAGE_WATCH;
    setGlobalPlayerScreenInControlOfState(source);
    this.fetchWatchData();
    setGlobalVideoDisabled({ value: false, source });
    setUserBookmarks({ profileBookmarks });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      accessToken,
      fetchWatchPanels,
      hasAccountOrProvider,
      isFreemium,
      panelVideo,
      params,
      profileId,
      setFreemiumModalVisibility,
      setUserBookmarks,
    } = this.props;
    const { accessToken: nextAccessToken, deviceId, params: nextParams } = nextProps;
    const { initialFreemiumVisibility } = this.state;
    const videoId = _.get(params, 'videoId');
    const nextVideoId = _.get(nextParams, 'videoId');

    if (videoId !== nextVideoId) {
      fetchWatchPanels(nextVideoId, nextAccessToken, deviceId);
      setUserBookmarks({ accessToken, profileId });
    }
    if (
      !initialFreemiumVisibility &&
      isFreemium &&
      !hasAccountOrProvider &&
      panelVideo &&
      !isNationLicensed(panelVideo)
    ) {
      setFreemiumModalVisibility({ visibility: true });
      this.setState({ initialFreemiumVisibility: true });
    }
  }

  shouldComponentUpdate(nextProps) {
    const newProps = this.getChangingProps(nextProps);
    const oldProps = this.getChangingProps(this.props);
    return !_.isEqual(newProps, oldProps);
  }

  componentDidUpdate(prevProps) {
    const {
      accessToken,
      breakpoint,
      clearSeriesDetail,
      deviceId,
      episodes,
      fetchMovieDetail,
      fetchSeries,
      isVodUnavailable,
      location,
      panels,
      panelVideo,
      seriesData,
      upNextVideo,
      video,
    } = this.props;
    const {
      accessToken: prevAccessToken,
      breakpoint: prevBreakpoint,
      episodes: prevEpisodes,
      isVodUnavailable: prevIsVodUnavailable,
      panels: prevPanels,
      panelVideo: nextPanelVideo,
      seriesData: prevSeriesData,
      upNextVideo: prevUpNextVideo,
      video: prevVideo,
    } = prevProps;
    const videoId = _.get(video, 'id');
    const prevVideoId = _.get(prevVideo, 'id');
    const videoChanged = videoId && prevVideoId !== videoId;
    const panelChanged = panels && panels !== prevPanels;
    const isShowCodeChanged = panelVideo?.showCode !== nextPanelVideo?.showCode;
    const episodeChanged = episodes?.length && episodes !== prevEpisodes;
    const breakpointChanged = breakpoint !== prevBreakpoint;
    const accessTokenChanged = accessToken !== prevAccessToken;
    const seriesDataChanged = seriesData !== prevSeriesData;
    const hash = _.trim(_.get(location, 'hash'), '#');
    const isLiveRestart = _.includes(hash, RESTART_TYPE_LIVE);
    const isDeeplink = !getPreviousPathname();
    const videoNotAvailable = !prevIsVodUnavailable && isVodUnavailable;

    if ((panelChanged || breakpointChanged) && episodes.length === 0) {
      fetchSeries(panelVideo?.showCode, accessToken, deviceId, panelVideo?.seasonNumber);
    }

    if (isShowCodeChanged && episodes.length > 0) {
      clearSeriesDetail();
      fetchSeries(panelVideo?.showCode, accessToken, deviceId, panelVideo?.seasonNumber);
    }

    if (videoNotAvailable && isDeeplink && isLiveRestart) {
      if (EpgEnabled) {
        browserHistory.push(helperGetLiveUrl());
      } else {
        // Redirects to home page for nation since it has no live page
        browserHistory.push(helperGetHomeUrl());
      }
    }
    if (accessTokenChanged) this.fetchWatchData();
    if (videoChanged) {
      const videoIsMovie = _.get(video, 'videoType') === 'movie';
      if (videoIsMovie) fetchMovieDetail(videoId, accessToken, deviceId);
    }

    if ((upNextVideo && upNextVideo !== prevUpNextVideo) || breakpointChanged) {
      this.setState({ upNextPanel: this.renderUpNextPanelVideos() });
    }

    if (
      episodeChanged ||
      breakpointChanged ||
      (seriesDataChanged && seriesData?.seasonCount === 0)
    ) {
      const primaryType = _.get(panels, 'member.0.items.member.0.videoType');
      this.setState({ primaryPanels: this.renderPrimaryPanels(primaryType) }, () => {
        const { primaryPanels } = this.state;
        if (primaryPanels) {
          // TODO: Temporary Solution
          this.forceUpdate();
        }
      });
    }
  }

  componentWillUnmount() {
    const {
      clearGlobalLiveRestart,
      clearGlobalVideo,
      clearWatch,
      restartVideo,
      setGlobalVideoDisabled,
      setWatchPage,
    } = this.props;
    const source = PAGE_WATCH;
    setGlobalVideoDisabled({ value: true, source });
    if (restartVideo) clearGlobalLiveRestart();
    clearGlobalVideo({ source });
    clearWatch();
    setWatchPage(false);
    deactivateWindowPreroll();

    if (!this.ignoreUnmountReferrerAnalytics) {
      this.trackPageReferrerAnalytics({
        name: PageNames.PLAYER,
      });
    }
  }

  getChangingProps = props => {
    const {
      accessToken,
      account,
      breakpoint,
      deviceId,
      episodes,
      errors,
      globalPanelVideo,
      globalVideo,
      hasAccountOrProvider,
      isAuthenticated,
      isFreemium,
      isVodUnavailable,
      location,
      pagination,
      panels,
      panelVideo,
      params,
      playlistData,
      preauthorizedResources,
      recommendationIdData,
      restartVideo,
      seo,
      seriesData,
      upNextHeadline,
      upNextVideo,
      video,
    } = props;
    return {
      accessToken,
      account,
      breakpoint,
      deviceId,
      episodes,
      errors,
      globalPanelVideo,
      globalVideo,
      hasAccountOrProvider,
      isAuthenticated,
      isFreemium,
      isVodUnavailable,
      location,
      pagination,
      panels,
      panelVideo,
      params,
      playlistData,
      preauthorizedResources,
      recommendationIdData,
      restartVideo,
      seo,
      seriesData,
      upNextHeadline,
      upNextVideo,
      video,
    };
  };

  onVodSectionClick = (opts = {}) => {
    const {
      clearGlobalLiveRestart,
      handleVodSectionClicked,
      setRecommendationId,
      recommendationIdData: currentRecIdData,
      restartVideo,
    } = this.props;
    const {
      account,
      itemIndex,
      originalItem,
      pageCollectionCount,
      percentWatched,
      position,
      recommendationIdData,
      sectionTitle,
      subtitleText,
      titleText,
      uiElement,
    } = opts;
    if (restartVideo) clearGlobalLiveRestart();
    const newRecIdData = recommendationIdData;
    checkRecommendationIdOnClick(currentRecIdData, newRecIdData, setRecommendationId);
    const isAnonymouslyResumingPlayback = !account && percentWatched;
    const vodClickedState = {
      anonymousResumeProfileUpsell: isAnonymouslyResumingPlayback && ProfileEnabled,
      anonymousResume: isAnonymouslyResumingPlayback && !ProfileEnabled,
      restartFromBeginning: false,
      isAuthError: false,
    };

    handleVodSectionClicked({ originalItem, vodClickedState });
    this.ignoreUnmountReferrerAnalytics = true;
    this.trackPageReferrerAnalytics({
      name: PageNames.VOD_SECTION,
    });

    const id = _.get(originalItem, 'id');
    const uID = _.get(originalItem, 'uID', '');
    const showCode = _.get(originalItem, 'showCode', '');
    const modelMetaData = originalItem?.trackingData?.properties?.modelMetaData;
    if (id) {
      handleAnalytics({
        event: Events.PLAYLIST_BUTTON_ACTION,
        pauload: {
          page_action_type: 'Watch Now',
          page_collection_count: pageCollectionCount - 1, // don't count the player panel
          page_collection_title: sectionTitle,
          page_item_title: titleText,
          page_item_subtitle: subtitleText,
          page_item_horizontal_position: itemIndex + 1,
          page_item_vertical_position: position,
          page_action_location: SegmentActionLocations.PLAYER,
          page_recs_collection_model_id: modelMetaData?.modelId ?? ' ',
          page_recs_collection_request_id: modelMetaData?.requestId ?? ' ',
          page_recs_collection_result_set_id: modelMetaData?.resultSetId ?? ' ',
          page_recs_collection_source_id: modelMetaData?.sourceId ?? ' ',
          page_ui_element: uiElement,
          page_video_uid: uID || showCode,
          ...getSegmentModelMetadata(),
        },
      });

      this.panelRenderPosition = 0;
    }
  };

  segmentPlaylistButtonAction = (opts = {}) => {
    const { sectionTitle, subtitleText, titleText, uiElement, originalItem } = opts;
    const modelMetaData = originalItem?.trackingData?.properties?.modelMetaData;
    handleAnalytics({
      event: Events.PLAYLIST_BUTTON_ACTION,
      payload: {
        page_action_type: 'Watch Now',
        page_collection_title: sectionTitle,
        page_item_title: titleText,
        page_item_subtitle: subtitleText,
        page_action_location: SegmentActionLocations.PLAYER,
        page_recs_collection_model_id: modelMetaData?.modelId ?? ' ',
        page_recs_collection_request_id: modelMetaData?.requestId ?? ' ',
        page_recs_collection_result_set_id: modelMetaData?.resultSetId ?? ' ',
        page_recs_collection_source_id: modelMetaData?.sourceId ?? ' ',
        page_ui_element: uiElement,
        ...getSegmentModelMetadata(),
      },
    });
  };

  getPaginationItemsFromPanelId = panelId => {
    const { pagination } = this.props;
    const paginationItems = _.get(pagination, `${panelId}`);
    if (!paginationItems) return [];
    return paginationItems.reduce((arr, items) => arr.concat(items.member), []);
  };

  getVideoId = () => {
    const { params } = this.props;
    return _.get(params, 'videoId');
  };

  isVideoNew = video => {
    if (!video) return false;
    const { episodeNumber, fullEpisodeCount } = video;
    return Math.floor(fullEpisodeCount / 2) < episodeNumber;
  };

  fetchWatchData() {
    const {
      accessToken,
      breakpoint,
      deviceId,
      fetchWatchPanels,
      globalPanelVideo,
      restartVideo,
      setGlobalVideoPanel,
      video,
    } = this.props;
    const videoIsMovie = _.get(video, 'videoType') === 'movie';
    const id = this.getVideoId();
    const videoIsSameAsGlobalVideo =
      !!globalPanelVideo && id === _.get(globalPanelVideo, 'id', null);
    let doNotSetGlobalVideoPanel =
      videoIsSameAsGlobalVideo ||
      (mobileWebRoadblockEnabled() && isMobileBreakpoint(breakpoint) && isNationEntitled());
    if (restartVideo) {
      doNotSetGlobalVideoPanel = true;
      setGlobalVideoPanel({ video: restartVideo, source: PAGE_WATCH });
      fetchWatchPanels(id, accessToken, deviceId, doNotSetGlobalVideoPanel);
    } else if (videoIsMovie && !isStaticRender()) {
      fetchMovieDetail(id, accessToken);
    } else if (fetchWatchPanels && !isStaticRender()) {
      fetchWatchPanels(id, accessToken, deviceId, doNotSetGlobalVideoPanel);
    }
  }

  usePlaylist() {
    const { playlistItems } = this.state;
    const { video } = this.props;
    const videoId = _.get(video, 'id');
    if (!playlistItems || !videoId) return false;
    return _.findKey(playlistItems, { id: videoId });
  }

  renderLoader() {
    const { globalVideo, panels, restartVideo, setLoading } = this.props;
    if (!panels && !globalVideo && !restartVideo) {
      return <Loader className={Style.loader} setLoading={setLoading} center />;
    }
    return null;
  }

  renderPanelVideos({ member, pageCollectionCount, position, primary }) {
    const {
      account,
      anonymousId,
      bookmarks,
      breakpoint,
      episodes,
      hasAccountOrProvider,
      isAuthenticated,
      panelVideo,
      params,
      playlistData,
      preauthorizedResources,
    } = this.props;
    const { playlist, playlistItems } = this.state;
    const panelId = _.get(member, 'id');
    const paginationItems = this.getPaginationItemsFromPanelId(panelId);
    const videoId = _.get(params, 'videoId');
    const usePlaylistResponse = this.usePlaylist();
    if (!primary && usePlaylistResponse) return null;
    const { badge_nowPlaying: badge } = window.Language;
    const { paginationMoreButton, paginationLessButton } = window.Language;

    const compactItems = _.compact([..._.get(member, 'items.member'), ...paginationItems]);
    const uniqItems = _.uniqBy(compactItems, item => item.id);
    let defaultItems = uniqItems.map(item =>
      _.assign({}, item, {
        isAuthenticated,
        preauthorizedResources,
      }),
    );

    if (
      videoId &&
      defaultItems.find(
        video => videoId === video.id && _.toLower(video.videoType) === 'fullepisode',
      )
    ) {
      // place current S/E first, all before it after
      const currentIndex = defaultItems.findIndex(item => item.id === videoId);
      const slicedItems = defaultItems.slice(currentIndex);
      const itemsBeforeCurrent = defaultItems.slice(0, currentIndex);
      defaultItems = [...slicedItems, ...itemsBeforeCurrent];
    }
    let items = defaultItems;
    let listProcessor = watchListVideoProcessor;
    let gridProcessor = watchVideoProcessor;
    if (usePlaylistResponse) {
      items = playlistItems;
      listProcessor = watchListPlaylistVideoProcessor.bind(this, playlist, {});
      gridProcessor = watchPlaylistVideoProcessor.bind(this, playlist, {});
    }
    items = _.map(items, item => {
      if (videoId === item.id) {
        return {
          ...item,
          contentLabel: [badge],
        };
      }
      return item;
    });
    const itemType = _.get(items, '0.videoType');
    const forceGrid = isMovie(itemType);
    const {
      gridToggleLimit,
      gridMovieToggleLimit,
      gridPrimaryToggleLimit,
      renderList,
    } = BREAKPOINTS[breakpoint];
    let toggleLimit = gridToggleLimit;
    if (isMovie(itemType)) {
      toggleLimit = gridMovieToggleLimit;
    } else if (primary) {
      toggleLimit = gridPrimaryToggleLimit;
    }
    if (primary && episodes.length && !isClip(itemType)) {
      items = episodes;
    }
    const titleData = getSectionTitleData({
      sectionItems: items,
      theme: Style,
      member: usePlaylistResponse ? playlistData : member,
      primary,
      forceGrid,
      isPlaylist: usePlaylistResponse,
      panelVideo,
    });
    const sectionTitle = _.get(titleData, 'sectionTitle');
    const sectionTitleClass = _.get(titleData, 'sectionTitleClass');
    const handleClick = opts =>
      this.onVodSectionClick({
        ...opts,
        pageCollectionCount,
        position,
        sectionTitle,
      });
    const mobileOverrideBreakpoint = primary && !forceGrid ? renderList : false;
    const grid = renderGrid({
      bookmarks,
      gridProcessor,
      gridType: !primary && !account && getOptimizelyWatchClipsLayout() ? 'grid-3-1' : 'grid-4-1',
      isAuthenticated,
      items,
      key: 'filteredPanel',
      listProcessor,
      listTheme: tileStyle,
      onLinkClick: handleClick,
      onTileClick: handleClick,
      onTitleClick: handleClick,
      onPlayClick: opts =>
        this.segmentPlaylistButtonAction({
          ...opts,
          pageCollectionCount,
          position,
          sectionTitle,
        }),
      paginationLessButton,
      paginationMoreButton,
      preauthorizedResources,
      renderList: mobileOverrideBreakpoint,
      renderImage: image =>
        renderImage({
          breakpoint,
          imageType: WATCH_RELATED_THUMBNAIL_IMAGE,
          ...image,
        }),
      scrollSeeLess: true,
      shouldRenderButtons: true,
      tileDetailToggle: true,
      tileGridTheme,
      tileGridTrackButtonClick: handleTealiumButtonAction,
      tileTheme: tileStyle,
      tileType: 'fadeAnimated',
      toggleLimit,
    });

    const isMobileOrTabletBreakpoint =
      isMobileBreakpoint(breakpoint) || isTabletBreakpoint(breakpoint);

    return (
      <Waypoint
        onEnter={() => {
          setOptimizelyCollectionViewedEvent({
            anonymousId,
            featuredTitle: sectionTitle,
            panelId,
            position,
          });
        }}
        bottomOffset="5%"
      >
        <div>
          {!hasAccountOrProvider &&
            !isMobileOrTabletBreakpoint &&
            this.renderCarousel({ items, primary, sectionTitle })}
          {(hasAccountOrProvider || isMobileOrTabletBreakpoint) && sectionTitle && items?.length ? (
            <h2 className={sectionTitleClass}>{sectionTitle}</h2>
          ) : null}
          {(hasAccountOrProvider || isMobileOrTabletBreakpoint) && grid}
        </div>
      </Waypoint>
    );
  }

  renderCarousel = ({ items, primary, sectionTitle }) => {
    const { breakpoint } = this.props;
    const {
      addCarouselPlaceholders,
      allowScrollLock,
      applyInlineBackground,
      bookmarks,
      carouselLimit,
      roundArrows,
      showCarouselArrows,
      showTileMetadataOnHover,
      slidesToScroll,
      subtitleLines,
      useScrollableDiv,
    } = BREAKPOINTS[breakpoint];
    const nonPrimaryTileLimit = 4;
    const upsellCtaText = window?.Language?.upsellPromoNavCTA;

    const anonymousProcessor = item => {
      const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
      const getProcessor = ({ videoType }) => {
        switch (videoType) {
          case isEpisode(videoType):
            return seriesVideoProcessor;
          case isClip(videoType):
            return clipsVideoProcessor;
          default:
            return seriesVideoProcessor;
        }
      };
      const processor = getProcessor({ videoType: item.videoType });
      return {
        ...processor({ bookmarks, item }),
        metadata: null,
        anonymousCTAText: upsellCtaText,
        anonymousCTAClick: () => {
          handleAnalytics({
            event: Events.PURCHASE_CTA_CLICKED,
            payload: {
              page_item_title: item.name,
              page_item_subtitle: item.description,
              page_action_location: 'anonymous series detail',
              page_button_text: upsellCtaText,
            },
          });
          redirectToExternalUrl(helperGetUpsellUrl());
        },
        hasOverlay: false,
        image: _.get(item, 'images.videoList.raw', null),
        isAnonymous: primary,
        isPlayable: !primary,
        link: `/watch/${item?.id}`,
        onTileClick: () => {},
        subtitle: !isMobile && item.description,
        target: '_self',
        titleLines: 0,
      };
    };

    const carouselProps = {
      addCarouselPlaceholders,
      allowScrollLock,
      applyInlineBackground,
      breakpoint,
      headline: sectionTitle,
      isInfinite: false,
      isPosters: false,
      isSeriesDetailAnonymous: true,
      items,
      processor: anonymousProcessor,
      roundArrows,
      showCarouselArrows,
      showTileMetadataOnHover,
      slidesToScroll: !primary ? slidesToScroll : nonPrimaryTileLimit,
      slidesToShow: !primary ? carouselLimit : nonPrimaryTileLimit,
      subtitleLines,
      theme: CarouselTheme,
      tileTheme: CarouselTileTheme,
      useScrollableDiv,
    };

    return <Carousel {...carouselProps} />;
  };

  renderUpNextPanelVideos = () => {
    const {
      account,
      bookmarks,
      breakpoint,
      isAuthenticated,
      preauthorizedResources,
      upNextHeadline,
      upNextVideo,
    } = this.props;

    const { gridUpNextToggleLimit, renderList } = BREAKPOINTS[breakpoint];

    if (!upNextVideo?.length) return null;

    const { paginationMoreButton, paginationLessButton } = window.Language;
    const listProcessor = watchListVideoProcessor;
    const gridProcessor = item =>
      watchVideoProcessor({
        ...item,
        account,
        bookmarks,
      });
    const items = upNextVideo;
    const handleClick = opts => this.onVodSectionClick({ ...opts, sectionTitle: upNextHeadline });

    const grid = renderGrid({
      gridProcessor,
      gridType: 'grid-5-4-3-1',
      isAuthenticated,
      items,
      key: 'filteredPanel',
      listProcessor,
      listTheme: tileStyle,
      onLinkClick: handleClick,
      onTileClick: handleClick,
      onTitleClick: handleClick,
      onPlayClick: opts =>
        this.segmentPlaylistButtonAction({ ...opts, sectionTitle: upNextHeadline }),
      paginationLessButton,
      paginationMoreButton,
      preauthorizedResources,
      renderList,
      renderImage: image =>
        renderImage({
          breakpoint,
          imageType: WATCH_RELATED_THUMBNAIL_IMAGE,
          ...image,
        }),
      scrollSeeLess: true,
      shouldRenderButtons: true,
      tileDetailToggle: true,
      tileGridTheme,
      tileGridTrackButtonClick: handleTealiumButtonAction,
      tileTheme: tileStyle,
      tileType: 'fadeAnimated',
      toggleLimit: gridUpNextToggleLimit,
    });

    return (
      <>
        <h2 className={Style.sectionTitle}>{upNextHeadline}</h2>
        {grid}
      </>
    );
  };

  renderPanels({ primary, primaryType }) {
    const { panels } = this.props;
    const panelList = _.get(panels, 'member');

    if (!panelList) return null;

    return panelList.map(member => {
      const id = _.get(member, '@id');
      const initialItems = _.get(member, 'items.member', []);
      const memberType = _.get(initialItems, '0.videoType');
      const panelType = _.get(member, 'panelType');

      if ((primaryType === memberType) !== primary) return null;

      switch (panelType) {
        case PANEL_TYPE_VIDEOS: {
          this.panelRenderPosition += 1;

          return initialItems.length > 0 ? (
            <div key={id} className={Style.videos}>
              {this.renderPanelVideos({
                member,
                pageCollectionCount: panelList?.length,
                position: this.panelRenderPosition,
                primary,
              })}
            </div>
          ) : null;
        }
        default:
          return null;
      }
    });
  }

  renderPrimaryPanels = primaryType => {
    const { hasAccountOrProvider, panelVideo } = this.props;
    const isPlaylistVariantActive = getPlaylistVariantActive({ panelVideo });
    let isPrimary = true;

    if (getOptimizelyWatchClipsLayout() && !hasAccountOrProvider) {
      isPrimary = false;
    }

    return (
      <>
        {!isPlaylistVariantActive && this.renderPanels({ primary: isPrimary, primaryType })}
        {this.renderPanels({ primary: !isPrimary, primaryType })}
      </>
    );
  };

  renderAnonymousView() {
    const { hasAccountOrProvider } = this.props;
    return !hasAccountOrProvider && <FloatingStartFreeTrial theme={Style} />;
  }

  render() {
    const {
      account,
      breakpoint,
      deviceId,
      errors,
      globalVideo,
      hasAccountOrProvider,
      panelVideo,
      seo,
      seriesData,
      video: reducerVideo,
    } = this.props;
    const { primaryPanels } = this.state;
    if (errors && !_.isArray(errors)) return getErrorComponent(errors);
    const video = reducerVideo || panelVideo || globalVideo;
    const network = _.get(video, 'network');
    const isVideoClip = video?.videoType === 'clip';
    const isMovieType = video?.videoType === 'movie';
    const setOverrideMetatags = brandOverrideMetaTags(network);
    const detailData = seriesData;
    let videoSchemaType = SCHEMA_TYPES.WATCH_EPISODE;
    if (isVideoClip) videoSchemaType = SCHEMA_TYPES.WATCH_CLIP;
    if (isMovieType) videoSchemaType = SCHEMA_TYPES.MOVIES;
    const videoSchema = { item: { ...video, detailData }, type: videoSchemaType };
    const videoObjectSchema = { item: video, type: SCHEMA_TYPES.VIDEO_OBJECT };
    const isPlaylistVariantActive = getPlaylistVariantActive({ panelVideo });
    const showRoadblock =
      mobileWebRoadblockEnabled() && isMobileBreakpoint(breakpoint) && isNationEntitled();

    return showRoadblock ? (
      <MobileWebRoadblock account={account} deviceId={deviceId} item={seriesData} />
    ) : (
      <>
        {setHelmetTags(seo)}
        <Schema schemas={[videoSchema, videoObjectSchema]} />
        {setOverrideMetatags}
        {this.renderLoader()}
        <div
          className={classNames([
            Style.container,
            isPlaylistVariantActive && Style.playlistActive,
            !hasAccountOrProvider && Style.anonymousContainer,
          ])}
        >
          {primaryPanels || (!isPlaylistVariantActive && <Loader className={Style.panelLoader} />)}
        </div>
        <BreadcrumbsComponent data={breadcrumbsWatchParser(video)} theme={breadcrumbsTheme} />
        {this.renderAnonymousView()}
      </>
    );
  }
}

function mapStateToProps(state) {
  const watchItems = [
    'endcardItems',
    'errors',
    'globalVideo',
    'isStatic',
    'isVodUnavailable',
    'pagination',
    'panels',
    'panelVideo',
    'releaseUrl',
    'schemaTags',
    'seo',
    'video',
  ];
  const watchProps = _.pick(state.watch, watchItems);
  return {
    ...watchProps,
    bookmarks: state.collection.bookmarks,
    episodes: state.seriesDetail.episodes,
    globalPanelVideo: makeSelectGlobalVideoPanelVideo(state),
    globalVideo: makeSelectGlobalVideoVideo(state),
    profileBookmarks: state.app.profileBookmarks,
    recommendationIdData: makeSelectAppRecommendationIdData(state),
    restartVideo: makeSelectGlobalVideoRestartVideo(state),
    seriesData: state.seriesDetail.seriesData,
    upNextHeadline: makeSelectGlobalUpNextHeadline(state),
    upNextVideo: makeSelectGlobalUpNextVideo(state),
  };
}

Watch.fetchData = ({ store, params, accessToken }) => {
  const id = params.videoId;
  return store.dispatch(fetchWatch(id, accessToken)).then(response => {
    const panels = _.get(response, 'payload.data.panels');
    const videoType = _.get(panels, 'member.0.items.member.0.videoType');
    const isMovieType = videoType === 'movie';
    store.dispatch(setGlobalVideoDisabled({ value: false, context: PAGE_WATCH }));
    if (!isMovieType) return store.dispatch(fetchWatchPanels(id, accessToken));
    return store.dispatch(fetchMovieDetail(id, accessToken));
  });
};

Watch.defaultProps = {
  accessToken: null,
  bookmarks: {},
  deviceId: null,
  episodes: [],
  errors: null,
  globalPanelVideo: null,
  globalVideo: null,
  isAuthenticated: false,
  isVodUnavailable: null,
  location: {},
  panels: {},
  panelVideo: null,
  playlistData: null,
  preauthorizedResources: [],
  recommendationIdData: null,
  restartVideo: null,
  seo: null,
  setLoading: null,
  setWatchPage: null,
  upNextHeadline: '',
  upNextVideo: [],
  video: {},
};

Watch.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  anonymousId: PropTypes.string,
  bookmarks: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  clearGlobalLiveRestart: PropTypes.func.isRequired,
  clearGlobalVideo: PropTypes.func.isRequired,
  clearSeriesDetail: PropTypes.func.isRequired,
  clearWatch: PropTypes.func.isRequired,
  deviceId: PropTypes.string,
  episodes: PropTypes.arrayOf(PropTypes.shape({})),
  errors: PropTypes.number,
  fetchMovieDetail: PropTypes.func.isRequired,
  fetchSeries: PropTypes.func.isRequired,
  fetchWatchPanels: PropTypes.func.isRequired,
  globalPanelVideo: PropTypes.shape({}),
  globalVideo: PropTypes.shape({}),
  hasAccountOrProvider: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isFreemium: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  location: PropTypes.shape({}),
  pagination: PropTypes.shape({}).isRequired,
  panelVideo: PropTypes.shape({}),
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  profileId: PropTypes.string,
  handleVodSectionClicked: PropTypes.func.isRequired,
  params: PropTypes.shape({ videoId: PropTypes.string }).isRequired,
  playlistData: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  restartVideo: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  seriesData: PropTypes.shape({}),
  setFreemiumModalVisibility: PropTypes.func.isRequired,
  setGlobalPlayerScreenInControlOfState: PropTypes.func.isRequired,
  setGlobalVideoDisabled: PropTypes.func.isRequired,
  setGlobalVideoPanel: PropTypes.func.isRequired,
  setLoading: PropTypes.func,
  profileBookmarks: PropTypes.shape({}),
  setRecommendationId: PropTypes.func.isRequired,
  setUserBookmarks: PropTypes.func.isRequired,
  setWatchPage: PropTypes.func,
  upNextHeadline: PropTypes.string,
  upNextVideo: PropTypes.arrayOf(PropTypes.shape({})),
  video: PropTypes.shape({}),
};

const TimeoutWatch = ReactTimeout(
  connect(mapStateToProps, {
    clearGlobalLiveRestart,
    clearGlobalVideo,
    clearSeriesDetail,
    clearWatch,
    fetchMovieDetail,
    fetchSeries,
    fetchWatch,
    fetchWatchPanels,
    handleVodSectionClicked,
    setGlobalPlayerScreenInControlOfState,
    setGlobalVideoDisabled,
    setGlobalVideoPanel,
    setRecommendationId,
    setUserBookmarks,
  })(Watch),
);

TimeoutWatch.fetchData = Watch.fetchData;

export default TimeoutWatch;
